
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment augmenter le trafic de votre site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez des stratégies éprouvées pour augmenter le trafic de votre site Internet et attirer plus de visiteurs en optimisant votre visibilité en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment augmenter le trafic de votre site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique comment générer du trafic sur votre site Internet.",
        },
      ],
    };
  },
};
